import { loadMore, scrollTo, triggerEvent } from './functions';

const productFilterMobileToggle = () => {
  const button = document.querySelector('a.toggle-shop-filter');
  const widgetContainer = document.querySelector('.shop-filter-widgets');

  button.addEventListener('click', (event) => {
    event.preventDefault();
    widgetContainer.classList.toggle('open');
  });
};

const productFilterTitleToggle = () => {
  const widgets = Array.from(document.querySelectorAll('.shop-filter-widgets .single-widget'));

  widgets.forEach((widget) => {
    const title = widget.querySelector('.widget-title');

    const haveChosen = widget.querySelector('.chosen');

    if (haveChosen) {
      widget.classList.toggle('open');
    }

    title.addEventListener('click', (event) => {
      event.preventDefault();
      widget.classList.toggle('open');
    });
  });

  const categories = Array.from(document.querySelectorAll('.shop-filter-widgets .widget_product_categories ul.product-categories > li'));

  categories.forEach((category) => {
    const title = category.querySelector(':scope > a');

    const haveChosen = category.querySelector('.current-cat');

    if (haveChosen) {
      category.classList.toggle('open');
    }

    title.addEventListener('click', (event) => {
      event.preventDefault();
      category.classList.toggle('open');
    });
  });
};

const productLoopFilter = () => {
  const filterLinks = Array.from(document.querySelectorAll('.wc-layered-nav-term > a'));
  const categoryLinks = Array.from(document.querySelectorAll('li.cat-item:not(.cat-parent) > a'));
  const activeFilterLinks = Array.from(document.querySelectorAll('.widget_layered_nav_filters a'));

  const links = filterLinks.concat(categoryLinks, activeFilterLinks);

  links.forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      // eslint-disable-next-line no-use-before-define
      fetchProductPageData(link.href);
    });
  });
};

export const fetchProductPageData = (link) => {
  const app = document.getElementById('main-content');
  const contentBuilder = document.querySelector('.content-builder-content');

  app.classList.add('wait');
  // contentBuilder.classList.add('wait');

  const scrollLocation = app.offsetTop - 200;

  if (window.scrollY > scrollLocation) {
    scrollTo(scrollLocation, 300);
  }

  jQuery.get(link, (response) => {
    const htmlObject = document.createElement('html');
    htmlObject.innerHTML = response;

    // const contentBuilderContent = document.querySelector('.content-builder-content');
    // const newContentBuilderContent = htmlObject.querySelector('.content-builder-content');
    const mainContent = document.getElementById('main-content');
    const newMainContent = htmlObject.querySelector('#main-content');
    // const breadcrumbs = document.querySelector('nav.woocommerce-breadcrumb');
    // const newBreadcrumbs = htmlObject.querySelector('nav.woocommerce-breadcrumb');
    const contentBelowLoop = document.querySelector('.content-below-product-loop');
    const newcontentBelowLoop = htmlObject.querySelector('.content-below-product-loop');

    if (document.body.classList.contains('admin-bar')) {
      const adminbar = document.getElementById('wpadminbar');
      const newAdminbar = htmlObject.querySelector('#wpadminbar');
      adminbar.innerHTML = newAdminbar.innerHTML;
    }

    // breadcrumbs.innerHTML = newBreadcrumbs.innerHTML;
    // contentBuilderContent.innerHTML = newContentBuilderContent.innerHTML;
    mainContent.innerHTML = newMainContent.innerHTML;

    contentBelowLoop.innerHTML = '';
    if (newcontentBelowLoop) {
      contentBelowLoop.innerHTML = newcontentBelowLoop.innerHTML;
    }

    document.body.classList = htmlObject.querySelector('body').classList;

    window.history.pushState({ html: htmlObject.html, pageTitle: response.pageTitle }, '', link);
    app.classList.remove('wait');
    // contentBuilder.classList.remove('wait');

    setTimeout(() => {
      productFilterMobileToggle();
      productFilterTitleToggle();
      productLoopFilter();
      loadMore('main.site-main .woocommerce-pagination ul.page-numbers a.next', 'main.site-main ul.products', 'main.site-main ul.products > li', 1250);
      triggerEvent(window, 'maksimer_category_change');

      jQuery('.woocommerce-ordering').on('change', 'select.orderby', function () {
        jQuery(this).closest('form').submit();
      });
    }, 100);
  });
};

if (document.body.classList.contains('tax-product_cat') || document.body.classList.contains('tax-pa_utfordringer') || document.body.classList.contains('tax-pa_virkestoffer')) {
  productFilterMobileToggle();
  productFilterTitleToggle();
  productLoopFilter();
}
